module.exports = __webpack_public_path__ + "static/img/img-3.691f7231.jpg";